import { Tooltip, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Config from '../../config'
import { setBackHandler } from '../../helpers/header.helper'
import { ImportContacts, ImportOutlookIntigrationIcon, MicroSoftImportContacts, MicrosoftImportContactsBetaFeature, NewBadgeIcon, SlackCircleSmallIcon } from '../../icon'
import * as selector from '../../selectors/selectors'
import { FileService } from '../../services/FileService'
import { AppRoutes } from '../routes/route.path'
import ButtonComponent from '../shared/button/button.component'
import { appNote, buttonLabels, IntegrationLabels } from '../shared/constants'
import { useNavigate } from 'react-router-dom'
import ImportContactsHistory from './contacts import history'
import { IntegrationSetupService } from '../../services/IntegrationSetup'
import { UserService } from '../../services/UserService'

interface IProps { }

const ImportContactsContainer = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);
    const navigate = useNavigate()
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const OrgId = UserService.getCurrentUserOrgId()
    const [integrationStatuses, setIntegrationStatuses] = useState([])

    const integrateOptions = [
        {
            id: 5,
            title: IntegrationLabels.OUTLOOK,
            code: IntegrationSetupService.OutlookIntigration_code,
            note: "Read and reply to FalkonSms messages from Slack channels",
            to: AppRoutes.OUTLOOK,
            staticViewIcon: <ImportOutlookIntigrationIcon />,
            listViewIcon: <SlackCircleSmallIcon width={30} height={30} />,
            badgeIcon: <NewBadgeIcon />,
        }
    ]

    //download sample execl file
    const handleDownloadXLSXfile = () => {
        FileService.downLoadFileByURL(Config.CONTACTS_TEMPLATE_URL_XLSX).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Contacts_Template.xlsx");
            link.click();
        })
            .catch(err => console.log("err", err))
    };

    const handleDownloadCSVfile = () => {
        FileService.downLoadFileByURL(Config.CONTACTS_TEMPLATE_URL_CSV).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Contacts_Template.csv");
            link.click();
        })
            .catch(err => console.log("err", err))
    }

    useEffect(() => {
        setBackHandler(() => navigate(AppRoutes.CONTACTS));
        setIsLoading(true)
        // IntegrationSetupService.getAllIntegrations(OrgId).then(res => {
        //     setIsLoading(false)
        //     let status = res.data?.filter(x => integrateOptions.some(option => option.code === x.integrationCode)).map(x => ({ code: x.integrationCode, status: x.integrationStatus }));
        //     setIntegrationStatuses(status)
        // })
        IntegrationSetupService.ImportContactOutlookStatus().then((res) => {
            setIntegrationStatuses((prevstatus) => {
                const filteredStatus = prevstatus.filter(status => status.code !== "OUTLOOK");
                return [...filteredStatus, { code: "OUTLOOK", status: res.data.status }];
            });
        })
    }, [])


    const getIntegrationStatus = (to, code) => {
        let status = integrationStatuses.find(x => x.code === code)?.status
        navigate(to + `?connection=${status === undefined ? false : status}`)
    }

    return (
        <>
            <div className={`ag-theme-alpine h-p-100 w-fill m-auto  ${IsMobileDevice ? "pt-1 pb-2" : IsDarkMode ? "bg-color-primary-background" : "p-2 bg-color-grid "}`}>
                <div className={`d-flex flex-direction mt-1 h-p-100 ${IsDarkMode ? "bg-color-primary-background" : "bg-color-login"} o-y-scroll`}>
                    <p className='mx-auto h1-regular my-6 color-primary-accent'>How would you like to import?</p>
                    <div className='d-flex justify-around'>
                        <div className={`${IsDarkMode ? "bg-color-primary-background" : "bg-color-secondary"} br-2 p-2 import-contacts-border d-flex flex-direction align-center justify-center w-p-27`}>
                            <Typography className={`h5-regular ${IsDarkMode ? "" : "color-import-contact-title"}  color-conv-card-title`}>
                                {appNote.IMPORT_EXCEL_FILE}
                            </Typography>
                            <div className='pt-6 pb-3'>
                                <ImportContacts />
                            </div>
                            <Typography className='h3-bold pb-5 color-primary-accent'>Select an XLSX or CSV file</Typography>
                            <div className='pb-1'>
                                <ButtonComponent ButtonLabel='Import from XLSX or CSV' Variant='primary-btn' ClassName='m-0' OnClick={() => navigate(AppRoutes.IMPORT_CONTACTS_EXCEL)} />
                            </div>
                            <Typography className={`h5-regular ${IsDarkMode ? "color-primary" : "color-import-contact-title"}  t-align-center`}>
                                {appNote.DOWNLOAD_SAMPLE_TEMPLATE}
                                &nbsp;
                                <span onClick={handleDownloadXLSXfile} className=" h5-regular color-primary-btn-focus c-pointer">
                                    {buttonLabels.XLSX}
                                </span>
                                &nbsp;or&nbsp;
                                <span onClick={handleDownloadCSVfile} className="h5-regular color-primary-btn-focus c-pointer">
                                    {buttonLabels.CSV}
                                </span>
                            </Typography>
                        </div>
                        <div className={`${IsDarkMode ? "bg-color-primary-background" : "bg-color-secondary"} br-2 p-2 import-contacts-border d-flex flex-direction align-center justify-center w-p-27 p-relative`}>
                            <Typography className={`h5-regular ${IsDarkMode ? "" : "color-import-contact-title"} color-conv-card-title`}>
                                {appNote.IMPORT_OUTLOOK}
                            </Typography>
                            <div className='pt-6 pb-3'>
                                <MicroSoftImportContacts />
                            </div>
                            <Typography className='h3-bold pb-5 color-primary-accent'>Import from Outlook</Typography>
                            <div className='pb-3'>
                                <ButtonComponent ButtonLabel='Import from Outlook' Variant='primary-btn' ClassName='m-0' OnClick={() => getIntegrationStatus(AppRoutes.OUTLOOK, IntegrationSetupService.OutlookIntigration_code)} />
                            </div>
                        </div>
                    </div>
                    <ImportContactsHistory
                        IsContacts={true}
                        IsScheduleMessages={false}
                        GridHeader="Import Contacts History"
                    />

                </div>
            </div>
        </>
    )
}

export default ImportContactsContainer